<div *ngIf="handleDashboard" class="main-content">
  <div class="container">
    <div [ngClass]="{'hidden':!showDashboard}">
    </div>
    <div fxLayout="row" fxLayout.xs="column" layout-wrap fxLayoutGap="30px">
      <div fxFlex="33" fxFlex.sm="47" fxFlex.xs="100">
        <app-module-block [clientAccess]="insuredPermission?'hide':''" [module]="modules[0]" (outputAction)="showSelectClient($event)"></app-module-block>
        <app-module-block [clientAccess]="claimsManagementPermission?'hide':''" [module]="modules[1]" (outputAction)="showSelectClient($event)"></app-module-block>
      </div>
      <div fxFlex="33" fxFlex.sm="47" fxFlex.xs="100">
        <app-module-block [clientAccess]="WaiverManagementPermission?'disabled':''" [module]="modules[2]" (outputAction)="showSelectClient($event)"></app-module-block>
        <!-- <mat-card class="blue-border-top dashboard-card">
          <div class="dashboard-card-disabled" *ngIf="!canAccess('WaiverManagement')"></div>
          <h2 class="uhc-h4">Waiver Management</h2>
          <ng-container *ngFor="let block of modules[2].blocks; let i = index">
            <div class="dasboard-card-block"
              *ngIf="canAccessWaiver?canAccess('WaiverManagement/'+block.blockName)&&!hideOnDashboard(block.blockName):true">
              <a fxLayoutGap="30px">
                <span fxFlex="10" class="block-image">
                  <img src="{{block.image}}" [ngClass]="{'img-disabled':!canAccess('WaiverManagement')}"
                    alt="{{block.blockName}} image" />
                </span>
                <span fxFlex>
                  <span class="block-heading" [ngClass]="{'block-heading-ds':!canAccess('WaiverManagement')}">
                    <a [href]="!canAccess('WaiverManagement')?'#':getFullUrl(block)" title="{{block.description}}">
                      {{block.blockName}}
                    </a>
                  </span><br />
                  <span class="block-description">{{block.description}}</span>
                </span>
              </a>
            </div>
          </ng-container>
        </mat-card> -->
      </div>
      <div fxFlex="33" fxFlex.sm="47" fxFlex.xs="100">
        <app-module-block [clientAccess]="PaymentManagementPermission?'hide':''" [module]="modules[3]" (outputAction)="showSelectClient($event)"></app-module-block>
        <app-need-assistance-card></app-need-assistance-card>
      </div>
    </div>
  </div>
</div>
